import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/89f2f8d9-74f4-4335-b690-b9a815d801c5/images/afc55b94e53cdaea07cc484a6c8586ef990891aaaf3c7324f9dbe441c8163b0f.png";

const SCOPE = [
  "Strip-out & waste clearance",
  "Site preparation & protection",
  "Plastering & re-plastering",
  "Drywall & partition build",
  "Flooring, tiling & carpentry",
  "Painting, decorating & snagging",
];

export default function Refurbishment() {
  return (
    <section
      id="refurbishment"
      data-testid="refurbishment-section"
      className="bg-white text-[#2B2420] border-y border-[#E5DDD0]"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative min-h-[420px] lg:min-h-[680px] bg-[#F5EFE5] overflow-hidden order-2 lg:order-1">
          <motion.div
            initial={{ scale: 1.04, opacity: 0.85 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.1 }}
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${IMG})` }}
          />
          <div className="absolute bottom-6 left-6 right-6 z-10">
            <div className="bg-white border border-[#E5DDD0] px-5 py-4 max-w-sm shadow-sm">
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#B8732C] font-bold mb-1">
                End-to-end
              </div>
              <div
                className="font-black text-xl md:text-2xl leading-[1.1] text-[#2B2420]"
                style={{ fontFamily: "Cabinet Grotesk" }}
              >
                One contractor. <br /> From strip-out to handover.
              </div>
            </div>
          </div>
        </div>

        <div className="px-6 md:px-12 lg:px-20 py-16 md:py-24 flex items-center order-1 lg:order-2">
          <div className="max-w-xl">
            <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#B8732C] mb-5">
              <span className="brand-gold-divider" /> From Demolition to Finish
            </div>
            <h2
              className="font-black tracking-tighter leading-[0.95] text-4xl md:text-5xl lg:text-6xl"
              style={{ fontFamily: "Cabinet Grotesk" }}
            >
              Strip it back. <br /> Build it beautifully.
            </h2>
            <p className="mt-6 text-base md:text-lg text-[#4D4037] leading-relaxed">
              CONSTANTINOV LTD covers every stage of a refurbishment — from
              the first strip-out to the final coat of paint. One team, one
              programme, one invoice. You save time, money and stress.
            </p>

            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {SCOPE.map((s) => (
                <li key={s} className="flex items-start gap-3 text-sm md:text-[15px] text-[#2B2420]">
                  <span className="mt-0.5 w-5 h-5 shrink-0 bg-[#B8732C] text-white flex items-center justify-center">
                    <Check className="w-3.5 h-3.5" strokeWidth={3} />
                  </span>
                  {s}
                </li>
              ))}
            </ul>

            <a
              href="#quote"
              data-testid="refurb-cta"
              className="mt-10 inline-flex items-center gap-2 bg-[#B8732C] hover:bg-[#9A5D1E] text-white px-6 py-4 text-sm font-bold uppercase tracking-[0.15em] transition-colors"
            >
              Discuss your project <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
